export default __webpack_public_path__ + "4ac5a9610171359514807fc86c2dd675.png";